import { useMutation } from "@tanstack/react-query";
import AIToolsAPI from "../../api/AIToolsAPI";
import { newToastEvent } from "../../../utils/ToastUtil";

interface SummarizeParameters {
  text: string;
  wordCount: number;
  language?: string;
}

const useSummarizeText = () => {
  const summarize = useMutation({
    mutationFn: ({ text, wordCount, language }: SummarizeParameters) =>
      AIToolsAPI.summarizeText(text, wordCount, language)
        .then((res) => res.data.data)
        .catch(() =>
          newToastEvent("error", "Something went wrong. Try again later.")
        ),
  });

  return {
    summarizeText: summarize.mutate,
    summarizeLoading: summarize.isPending,
    summarizeError: summarize.error,
    summary: summarize.data,
    restart: summarize.reset,
  };
};

export default useSummarizeText;
